import styled from 'styled-components';

const ItemSummariesView = styled.div`
  display: flex;
  margin-bottom: 0.5em;
  height: 4em;
`;

export default ItemSummariesView;
